import { types } from "../types/legend";
//import { types as mapTypes } from "../types/map";
import { cloneDeep } from "lodash";

const initialState = {
  legendVisibility: false,
  hiddenObjectTypesIndexes: [],
  allDrawnObjectsVisibility: true,
  hiddenDrawnPolygonTypesIndexes: [],
  allDrawnTreesVisibility: true,
  topographyVisibility: false,
  maxElevation: null,
  minElevation: null,
  topographyUrl: null,
  topographyBounds: null,
  extraTopo: [],
  allDrawnEmissionVisibility: true,
  allDrawnMapPoiVisibility: true,
  allDrawnWindTurbineVisibility: true,
  windTurbineTooltipVisibility: false,
  mapPoiTooltipVisibility: false,
};

const legendReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.TOGGLE_ALL_DRAWN_OBJECTS_VISIBILITY:
      return {
        ...state,
        allDrawnObjectsVisibility: !state.allDrawnObjectsVisibility,
      };

    case types.TOGGLE_ALL_DRAWN_TREES_VISIBILITY:
      return {
        ...state,
        allDrawnTreesVisibility: !state.allDrawnTreesVisibility,
      };

    case types.TOGGLE_DRAWN_POLYGON_TYPE_VISIBILITY: {
      const typeIndex = action.payload;
      let hidden = [...state.hiddenDrawnPolygonTypesIndexes];
      if (hidden.includes(typeIndex)) {
        hidden = hidden.filter((x) => x !== typeIndex);
      } else {
        hidden.push(typeIndex);
      }
      return { ...state, hiddenDrawnPolygonTypesIndexes: hidden };
    }

    case types.TOGGLE_TOPOGRAPHY_VISIBILITY:
      return {
        ...state,
        topographyVisibility: !state.topographyVisibility,
      };
    case types.SET_HIDDEN_OBJECT_TYPES_INDEXES:
      return {
        ...state,
        hiddenObjectTypesIndexes: action.payload,
      };

    case types.RESET_LEGEND:
      return {
        ...initialState,
      };
    case types.SHOW_LEGEND:
      return {
        ...state,
        legendVisibility: true,
      };

    case types.HIDE_LEGEND:
      return {
        ...state,
        legendVisibility: false,
      };
    case types.HIDE_TOPOGRAPHY:
      return {
        ...state,
        topographyVisibility: false,
      };

    case types.GET_LEGEND_DATA:
      return {
        ...state,
        topographyUrl: action.payload.topographyUrl,
        maxElevation: action.payload.maxElevation,
        minElevation: action.payload.minElevation,
        topographyBounds: action.payload.topographyBounds ?? state.topographyBounds,
      };

    case types.SET_TOPOGRAPHY_MAP_BOUNDS:
      return {
        ...state,
        topographyBounds: action.payload,
      };

    case types.SET_EXTRA_TOPOGRAPHY_VISIBILITY: {
      const extraTopoName = action.payload;
      const extraTopo = cloneDeep(state.extraTopo);
      const extraTopoIndex = extraTopo.findIndex((x) => {
        return x.name === extraTopoName;
      });

      const prevChecked = extraTopo[extraTopoIndex].checked;
      extraTopo[extraTopoIndex].checked = !prevChecked;

      return {
        ...state,
        extraTopo: extraTopo,
      };
    }
    case types.GET_EXTRA_LEGEND_DATA_PROPS:
      return {
        ...state,
        extraTopo: action.payload,
      };

    case types.TOGGLE_WIND_TURBINE_TOOLTIP: {
      return {
        ...state,
        windTurbineTooltipVisibility: !state.windTurbineTooltipVisibility,
      };
    }
    case types.TOGGLE_MAP_POI_TOOLTIP: {
      return {
        ...state,
        mapPoiTooltipVisibility: !state.mapPoiTooltipVisibility,
      };
    }
    default:
      return state;
  }
};

export default legendReducer;
